import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Simulator: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="simulator">
      <h1>{t.pages.simulatorTitle}</h1>
      <p>{t.pages.simulatorDescription}</p>
    </div>
  );
};

export default Simulator;
